// タブ切り替え
$(function() {
  $('.popup_select_tab_menu li').on('click tap', function() {
    const tabmenu = $(this).parents('.popup_select_tab_menu');
    const datatab = $(tabmenu).data('tab');
    const tabpanel = $('#' + datatab);
    const index = $(this).index();

    $('ul[data-tab='+ datatab +']').each(function() {
      $(this).children().removeClass('selected');
      $(this).children().eq(index).addClass('selected');
    });

    $('select[data-tab='+ datatab +']').each(function() {
      $(this).prop('selectedIndex', index);
    });

    tabpanel.children().removeClass('is-show');
    tabpanel.children().eq(index).addClass('is-show');
  });
});

// popup
$(function() {
  $('#popup_open').magnificPopup({
    fixedBgPos: true,
    items: {
      src: '#popup_content'
    },
    callbacks: {
      beforeOpen: function () {
        $('html').css("overflow", "hidden");

        // タブ初期表示設定
        let member = true
        let addClass = ""
        let removeClass = ""

        if ($('#template_hidden').val()) {
          // 上書き確認ダイアログから「いいえ」で戻ってきて、ポップアップ再表示
          member = $('#template_hidden').val() == "member"
        } else {
          // 画面から普通にポップアップ表示
          member = $('#radio-01').prop("checked")
        }
        if (member) {
          addClass = "1"; removeClass = "2"
        } else {
          addClass = "2"; removeClass = "1"
        }

        $(`.popup_select_tab0${addClass}`).addClass("selected");
        $(`.tab_group0${addClass}`).addClass("is-show");
        $(`.popup_select_tab0${removeClass}`).removeClass("selected");
        $(`.tab_group0${removeClass}`).removeClass("is-show");
      },
      close: function() {
        $('#template_hidden').val("");
        $('html').css("overflow", "");
      },
    },
  });
});

//投稿例から記事を作成する押下時
$(function() {
  $('.recruit_member, .recruit_job').on('click tap', function(e){
    // 既に投稿内容に入力があった場合は確認ポップアップ表示、無ければダイレクトにテンプレ反映
    if ($('#work_article_body').val().trim()) {
      $.magnificPopup.close()
      const alertmsg = ()=> {
        $.magnificPopup.open({
          items: {src: '#popup_set_template'},
          type: 'inline',
          fixedContentPos: true
        }, 0);
      }
      setTimeout(alertmsg, 1);
    } else {
      setTemplate();
    }
  });

  // 上書き確認ポップアップの処理
  $('#overwrite_yes, #overwrite_no').click(function(e) {
    if (e.target.id.includes('yes')) {
      setTemplate();
    } else {
      // 上書きでnoを選択した場合、選択状態を復元した状態で再度ポップアップを開く
      const selectedTab = getSelectedTab()
      $.magnificPopup.close();
      $('#template_hidden').val(selectedTab)
      const alertmsg = ()=> { $('#popup_open').trigger('click'); }
      setTimeout(alertmsg, 1)
    }
  });
});

// 選択した投稿例を反映
function setTemplate() {
  const template = $(`#template_recruit_${getSelectedTab()}`);
  $('#work_article_body').val(template.html().replace(/<br>/g, '\n'));
  $.magnificPopup.close()
}

// 選択されたタブの文字列を返却
function getSelectedTab() {
  return $('.popup_select_tab01').hasClass("selected") ? "member" : "job";
}

// 選択されてるカテゴリに応じて、【職人募集】と【仕事募集】のフォーム状態を判定
$(document).ready(function () {
  const $inputRecruitmentOrderingName = $('input[name="input_recruitment_ordering_name"]');
  const $inputJobSearchOrderName = $('input[name="input_job_search_order_name"]');

  // 画面を開いたとき実行
  handleRadioSelection();

  // カテゴリを切り替えたとき実行
  $('.radio-input').on('change', function () {
    handleRadioSelection();
  });

  function handleRadioSelection() {
    const selectedValue = parseInt($('.radio-input:checked').val());

    switch (selectedValue) {
      case 1:
        $inputJobSearchOrderName.val('').addClass('disabled').prop('disabled', true);
        $inputRecruitmentOrderingName.prop('disabled', false).removeClass('disabled');
        break;
      case 2:
        $inputRecruitmentOrderingName.val('').addClass('disabled').prop('disabled', true);
        $inputJobSearchOrderName.prop('disabled', false).removeClass('disabled');
        break;
      default:
        $inputRecruitmentOrderingName.prop('disabled', false).removeClass('disabled');
        $inputJobSearchOrderName.prop('disabled', false).removeClass('disabled');
    }
  }
});